import type { IxfHoursV1ExceptionKeys } from '@interxfi/types';
import { type EntityPathBuilder, getResolvedPath } from '../../../util/routing/entity-paths';

export const HOURS_EXCEPTION_BASE_PATH = getResolvedPath('/hours/exception');

export const getHoursExceptionPath: EntityPathBuilder<IxfHoursV1ExceptionKeys> = (context) => {
  switch (context.kind) {
    case 'list':
      return HOURS_EXCEPTION_BASE_PATH;
    case 'detail': {
      if (!context?.keys?.exceptionId) {
        return undefined;
      }

      return getResolvedPath(`${HOURS_EXCEPTION_BASE_PATH}/$exceptionId`, context?.keys);
    }
  }
};

export function getHoursExceptionDetailPath(exceptionId: string | undefined) {
  if (!exceptionId) {
    return undefined;
  }

  return getHoursExceptionPath({ kind: 'detail', keys: { exceptionId } });
}
